const transactionStatusOptions: { [key: string]: string } = {
  pending: 'Pending',
  'in progress': 'In Progress',
  requested: 'Requested',
  sent: 'Sent',
  successful: 'Successful',
  complete: 'Complete',
  failed: 'Failed',
  cancelled: 'Cancelled',
  'cancellation requested': 'Cancellation Requested',
  settled: 'Settled',
  waiting: 'Waiting',
};

export default transactionStatusOptions;
